import { Layout, Data } from '@pcmp/react-coworker-components';

import {
  FilterBarDesktop,
  FilterBarMobile,
} from '@/components/page-widgets/codes/filters';
import { SearchBar } from '@/components/page-widgets/codes/search';
import { CodesTable } from '@/components/page-widgets/codes/table';
import { useGetV1UsersMeQuery } from '@/redux/apis/frontend-api';
import { LoadingFullScreen } from '@/components/helpers/loading/index';
import { useState } from 'react';
import { ActionBar } from '@/components/page-widgets/codes/actions';
import { CodeV2 as Code } from '@/redux/apis/codes-api';

const { Container } = Layout;
const { Card } = Data;

function CodesPage() {
  const { data: userData } = useGetV1UsersMeQuery();
  const [selectedCodes, setSelectedCodes] = useState<Code[]>([]);

  if (!userData) return <LoadingFullScreen />;

  return (
    <div className="pb-[56px]">
      <Container className="px-0 sm:px-8 sm:py-16 min-h-[100%] sm:bg-transparent pb-12">
        <Card className="flex flex-col items-center sm:min-h-[653px]">
          <FilterBarDesktop />
          <FilterBarMobile />
          {selectedCodes.length > 0 ? (
            <ActionBar selectedCodes={selectedCodes} />
          ) : (
            <SearchBar />
          )}
          <CodesTable user={userData} setSelectedCodes={setSelectedCodes} />
        </Card>
      </Container>
    </div>
  );
}

export default CodesPage;
